import type { ColumnDef } from "./types";
import { plainFormattedValue } from "./formatters";

function escapeCsvCell(value: string): string {
  if (/[",\n\r]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

/**
 * 匯出「目前篩選/排序後的全部資料」（不只當頁），對齊舊 kartik ExportMenu 行為。
 * 只匯出目前可見（visible）且非 action/checkbox 欄位。
 */
export function buildCsv<T>(columns: ColumnDef<T>[], rows: T[]): string {
  const exportCols = columns.filter(
    (c) => c.visible !== false && c.kind !== "action" && c.kind !== "checkbox",
  );
  const header = exportCols.map((c) => escapeCsvCell(c.label)).join(",");
  const lines = rows.map((row) =>
    exportCols
      .map((c) => {
        const v = c.exportValue ? c.exportValue(row) : plainFormattedValue(c, row);
        return escapeCsvCell(String(v ?? ""));
      })
      .join(","),
  );
  // BOM 讓 Excel 開啟中文不亂碼
  return `﻿${[header, ...lines].join("\r\n")}`;
}

export function downloadCsv(fileName: string, csv: string): void {
  if (typeof document === "undefined") return;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName.endsWith(".csv") ? fileName : `${fileName}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
